<!--
 * @Description: 变更记录
 * @Author: 钱磊
 * @Date: 2022-07-25 17:22:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-08-19 08:46:44
-->
<!--  -->
<template>
  <div class="operation-layout h100">
    <!-- 变更记录 -->
    <!-- 变更记录筛选条件 -->
    <div class="filter" v-if="!showDetail">
      <span class="mr20">修改模块</span>
      <el-select
        v-model="searchObj.modelType"
        placeholder="请选择模块"
        clearable
        @change="getLibChanges"
        size="small"
      >
        <el-option label="全部" value=""></el-option>
        <el-option label="基础信息维护" value="0"></el-option>
        <el-option label="归属单位维护" value="1"></el-option>
        <!-- <el-option label="专家专业类别" value="3"></el-option> -->
      </el-select>
    </div>
    <!-- 变更记录列表 -->
    <div
      class="operation-container w-table-layout w-table-page mt20"
      v-if="!showDetail"
    >
      <div class="w-table-content">
        <vxe-table
          :data="tableObj.tableData"
          :loading="tableObj.loading"
          :border="tableObj.border"
          :resizable="tableObj.resizable"
          :size="tableObj.size"
          :height="tableObj.height"
          highlight-current-row
          highlight-hover-row
          show-overflow="tooltip"
          show-header-overflow="tooltip"
        >
          <vxe-table-column
            type="seq"
            title="序号"
            align="center"
            width="70"
          ></vxe-table-column>
          <vxe-table-column
            title="修改模块"
            header-align="center"
            align="center"
            show-overflow-tooltip
          >
            <template v-slot="{ row }">
              {{ row.modelType | typeFilter }}
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="applyBusName"
            title="修改单位"
            align="center"
          >
            <template v-slot="{ row }">
              {{ row.changeUnit ? row.changeUnit : "-" }}
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="createUser"
            title="修改人"
            align="center"
            width="100"
          ></vxe-table-column>
          <vxe-table-column
            field="createDate"
            title="修改日期"
            align="center"
            width="140"
          ></vxe-table-column>
          <vxe-table-column title="操作" align="center">
            <template v-slot="{ row }">
              <el-button
                type="success"
                size="small"
                round
                plain
                class="table-btn"
                :disabled="row.ruleStatus == 1"
                @click="handleCheck(row)"
              >
                <svg-icon icon-class="form-look"></svg-icon> 查看
              </el-button>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <div class="w-table-footer">
        <vxe-pager
          size="mini"
          :current-page="searchObj.currentPage"
          :page-size="searchObj.pageSize"
          :total="searchObj.totalResult"
          class="text-center"
          :layouts="['Total', 'PrevPage', 'JumpNumber', 'NextPage', 'FullJump']"
          @page-change="handlePageChange"
        >
        </vxe-pager>
      </div>
    </div>
    <!-- 变更记录详情 -->
    <div class="details" v-if="showDetail">
      <!-- 返回按钮 -->
      <div class="back" @click="handleBack"><img src="../../../../assets/images/back.png" alt=""> 返回</div>
      <h3>原内容：</h3>
      <!-- 修改前基本信息 -->
      <div class="base-info" v-if="changeDetail.modelType=='0'">
        <el-row>
          <el-col :span="5">
            <p>
              专家库状态：{{
                changeDetail.beforeDetails.status == "0" ? "关闭" : "启用"
              }}
            </p>
          </el-col>
          <el-col :span="5">
            <p>应用库名称：{{ changeDetail.beforeDetails.sname }}</p>
          </el-col>
          <el-col :span="5">
            <p>
              专家库类型：{{
                changeDetail.beforeDetails.libType == "0"
                  ? "企业专家库"
                  : "平台专家库"
              }}
            </p>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5">
            <p>
              是否接受专家入库申请：{{
                changeDetail.beforeDetails.isAccept == "0" ? "否" : "是"
              }}
            </p>
          </el-col>
          <el-col :span="5">
            <p>应用库简称：{{ changeDetail.beforeDetails.shortName }}</p>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5">
            <p>
              是否在客户端展示：{{
                changeDetail.beforeDetails.isShow == "0" ? "否" : "是"
              }}
            </p>
          </el-col>
          <el-col :span="5">
            <p>应用库用途：{{ changeDetail.beforeDetails.libApply }}</p>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2">
            <p>
              库备注说明：
            </p>
          </el-col>
          <el-col :span="12">
            <p v-html="changeDetail.beforeDetails.remark"></p>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2">
            <p>库对外开放说明：</p>
          </el-col>
          <el-col :span="12">
            <p v-html="changeDetail.beforeDetails.openRemark"></p>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2">
            <p>入库标准：</p>
          </el-col>
          <el-col :span="12">
            <p v-html="changeDetail.beforeDetails.applyStandard"></p>
          </el-col>
        </el-row>
      </div>
      <!-- 修改前归属单位 -->
      <div class="belong" v-if="changeDetail.modelType=='1'">
        <el-row>
          <el-col :span="22">
            <p>归属单位：{{ changeDetail.beforeDetails.gsUnits }}</p>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <p>管理单位：{{ changeDetail.beforeDetails.glUnits }}</p>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <p>
              专家库开放使用单位：{{
                changeDetail.beforeDetails.isOpen == "1"
                  ? "全部单位"
                  : "指定单位"
              }}<span v-if="changeDetail.beforeDetails.isOpen == '0'"
                >({{ changeDetail.beforeDetails.kfUnits }})</span
              >
            </p>
          </el-col>
        </el-row>
      </div>
      <hr />
      <h3>修改后内容：</h3>
      <span class="creater">修改人：{{ changeDetail.createUser }}</span>
      <span class="creater">修改时间：{{ changeDetail.createDate }}</span>
      <!-- 修改后基本信息 -->
      <div class="base-info" v-if="changeDetail.modelType=='0'">
        <el-row>
          <el-col :span="5">
            <p>
              专家库状态：{{
                changeDetail.afterDetails.status == "0" ? "关闭" : "启用"
              }}
            </p>
          </el-col>
          <el-col :span="5">
            <p>应用库名称：{{ changeDetail.afterDetails.sname }}</p>
          </el-col>
          <el-col :span="5">
            <p>
              专家库类型：{{
                changeDetail.afterDetails.libType == "0"
                  ? "企业专家库"
                  : "平台专家库"
              }}
            </p>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5">
            <p>
              是否接受专家入库申请：{{
                changeDetail.afterDetails.isAccept == "0" ? "否" : "是"
              }}
            </p>
          </el-col>
          <el-col :span="5">
            <p>应用库简称：{{ changeDetail.afterDetails.shortName }}</p>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5">
            <p>
              是否在客户端展示：{{
                changeDetail.afterDetails.isShow == "0" ? "否" : "是"
              }}
            </p>
          </el-col>
          <el-col :span="5">
            <p>应用库用途：{{ changeDetail.afterDetails.libApply }}</p>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2">
            <p>
              库备注说明：
            </p>
          </el-col>
          <el-col :span="12">
            <p v-html="changeDetail.afterDetails.remark"></p>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2">
            <p>库对外开放说明：</p>
          </el-col>
          <el-col :span="12">
            <p v-html="changeDetail.afterDetails.openRemark"></p>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2">
            <p>入库标准：</p>
          </el-col>
          <el-col :span="12">
            <p v-html="changeDetail.afterDetails.applyStandard"></p>
          </el-col>
        </el-row>
      </div>
      <!-- 修改后归属单位 -->
      <div class="belong" v-if="changeDetail.modelType=='1'">
        <el-row>
          <el-col :span="22">
            <p>归属单位：{{ changeDetail.afterDetails.gsUnits }}</p>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <p>管理单位：{{ changeDetail.afterDetails.glUnits }}</p>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <p>
              专家库开放使用单位：{{
                changeDetail.afterDetails.isOpen == "1"
                  ? "全部单位"
                  : "指定单位"
              }}<span v-if="changeDetail.afterDetails.isOpen == '0'"
                >（{{ changeDetail.afterDetails.kfUnits }}）</span
              >
            </p>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { getLibChanges } from "api/modules/expert_gz.js";
export default {
  props: {
    libId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      searchObj: {
        modelType: "", // 修改模块
        currentPage: 1, // 当前页码
        pageSize: 12, // 当前每页条数
        totalResult: 0,
      },
      // 表格对象
      tableObj: {
        tableData: [],
        loading: false,
        border: true,
        resizable: true,
        size: "small",
        height: '100%'
      },
      showDetail: false, //是否显示变更详情
      changeDetail: {}, //变更记录详情
    };
  },
  filters: {
    typeFilter(val) {
      if (val == "0") {
        return "基础信息维护";
      } else if (val == "1") {
        return "归属单位维护";
      }
    },
  },
  components: {},
  mounted() {
    if (this.$getSessionItem("showDetail")) {
      this.showDetail = JSON.parse(this.$getSessionItem("showDetail"));
      // 移除 避免污染
      this.$removeSessionItem("showDetail");
    }
    if (this.$getSessionItem("changeDetail")) {
      this.changeDetail = JSON.parse(this.$getSessionItem("changeDetail"));
      // 移除 避免污染
      this.$removeSessionItem("changeDetail");
    }
    if(this.libId!=''){
      this.getLibChanges();
    }
  },
  methods: {
    // 获取变更记录
    getLibChanges() {
      let params = {
        libId: this.libId,
        modelType: this.searchObj.modelType,
        size: this.searchObj.pageSize,
        current: this.searchObj.currentPage,
      };
      getLibChanges(params).then((res) => {
        if (res.operationCode == "1") {
          this.tableObj.tableData = res.data.records;
          this.searchObj.totalResult = parseInt(res.data.total);
        }
      });
    },
    // 查看详情
    handleCheck(rows) {
      this.changeDetail = Object.assign({}, rows);
      this.showDetail = true;
      this.$setSessionItem("showDetail", JSON.stringify(this.showDetail));
      this.$setSessionItem("changeDetail", JSON.stringify(this.changeDetail));
    },
    // 返回按钮
    handleBack(){
      this.showDetail = false;
      this.$removeSessionItem("showDetail");
      this.$removeSessionItem("changeDetail");
    },
    // 切换分页
    handlePageChange({ currentPage, pageSize }) {
      this.searchObj.currentPage = currentPage;
      this.getLibChanges();
    },
  },
  computed: {},
};
</script>
<style scoped lang='less'>
.filter {
  font-size: 14px;
}
.details {
  position: relative;
  height: 100%;
  .back {
    z-index:999;
    width: 60px;
    height: 30px;
    position: absolute;
    top: 10px;
    right: 10px;
    color:#169bd5;
    font-size: 14px;
    cursor: pointer;

  }
  .base-info,.belong {
    p {
      font-size: 13px;
      padding: 8px 0;
    }
  }
  h3 {
    display: inline-block;
    font-size: 14px;
  }
  hr {
    height: 6px;
    background-color: #f2f2f2;
    border: none;
    margin: 10px 0;
  }
  .creater {
    font-size: 13px;
    margin-left: 15px;
  }
}
</style>
